'use client';

import { useTranslations } from 'next-intl';
import { lazy, Suspense, useCallback, useState } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { Button } from '@//components/Button';
import { useLegacyTrackOptionsClick } from '@//data/tracking/useLegacyTrackOptionsClick';
import { useTriggerOnce } from '@//hooks/useTriggerOnce';

const EquipmentModal = lazy(() => import('./EquipmentModal'));

interface AllEquipmentProps {
  vehicle: ElasticVehicle;
}

export const AllEquipment = ({ vehicle }: AllEquipmentProps) => {
  const t = useTranslations('pages.item.equipmentSection');
  const { trackLegacyOptionsClick } = useLegacyTrackOptionsClick();
  const [modal, setModal] = useState(false);

  const trackLegacyOptionsClickOnce = useTriggerOnce(() => trackLegacyOptionsClick(vehicle));

  const onOpen = useCallback(() => {
    trackLegacyOptionsClickOnce();
    setModal(true);
  }, [trackLegacyOptionsClickOnce]);

  const onClose = useCallback(() => setModal(false), []);

  return (
    <>
      <Suspense fallback={null}>
        <EquipmentModal vehicle={vehicle} isOpen={modal} onClose={onClose} />
      </Suspense>
      <Button
        size="lg"
        variant="secondary"
        fullWidthLtMd
        onClick={onOpen}
        title={t('showAllButton.title')}
      >
        {t('showAllButton.label')}
      </Button>
    </>
  );
};
